import { Switch } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface WsSwitchProps {
  name: string;
}

export default function WsSwitch({ name }: WsSwitchProps) {
  const form = useFormContext();

  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field: { value, onChange } }) => (
        <Switch
          checked={value}
          onChange={(event) => onChange(event.target.checked)}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      )}
    />
  );
}
